import { DfiReportsResponse, DfiReportResponse, KpiLateResponse } from 'types';

export const MOCK_DFI_ANNUAL_REPORTS_DATA: DfiReportsResponse = {
  listDfiAnnualReportItems: [
    {
      id: 1,
      reportYear: 2022,
    },
    {
      id: 2,
      reportYear: 2021,
      dateCompleted: new Date('2022-06-10'),
    },
    {
      id: 3,
      reportYear: 2020,
      dateCompleted: new Date('2021-07-01'),
    },
    {
      id: 4,
      reportYear: 2019,
      dateCompleted: new Date('2020-05-27'),
    },
  ],
};

export const MOCK_LATE_RESPONSE_ITEMS_STATS: KpiLateResponse[] = [
  {
    lateResponseReason: 'Resource issues',
    lateResponseReasonCount: 30,
    lateResponseReasonPercentage: 38,
  },
  {
    lateResponseReason: 'High volume of work',
    lateResponseReasonCount: 10,
    lateResponseReasonPercentage: 13,
  },
  {
    lateResponseReason: 'Extension request refused',
    lateResponseReasonCount: 4,
    lateResponseReasonPercentage: 5,
  },
  {
    lateResponseReason: 'Tech issues - internal to the organisation',
    lateResponseReasonCount: 8,
    lateResponseReasonPercentage: 10,
  },
  {
    lateResponseReason: 'Tech issues - external to the organisation',
    lateResponseReasonCount: 12,
    lateResponseReasonPercentage: 15,
  },
  {
    lateResponseReason: 'Complexity of the case',
    lateResponseReasonCount: 11,
    lateResponseReasonPercentage: 14,
  },
  {
    lateResponseReason: 'Additional information required after consultation',
    lateResponseReasonCount: 3,
    lateResponseReasonPercentage: 4,
  },
  {
    lateResponseReason: 'Other',
    lateResponseReasonCount: 1,
    lateResponseReasonPercentage: 1,
  },
];

export const MOCK_DRAFT_DFI_ANNUAL_REPORT_RESPONSE_DATA: DfiReportResponse = {
  reportYear: 2022,
  parentOrganisationName: 'Organisation 1',
  consulteeName: 'Bill Zuma',
  dateModified: new Date('2022-06-10'),
  infoOnLateResponse:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  bestPracticeResponse:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  statutoryTimelinessResponseStats: {
    totalConsultationRequestsReceived: 500,
    totalConsultationsRespondedInAgreedTimeframe: 400,
    percentageConsultationsRespondedInAgreedTimeframe: 80,
    totalConsultationsWithResponsesWithin21Days: 300,
    percentageConsultationsWithResponsesWithin21Days: 60,
    totalConsultationsRespondedLate: 100,
    percentageConsultationsRespondedLate: 20,
    totalConsultationsWithOutstandingResponses: 10,
    averageDaysTakenToRespondRequests: 2,
  },

  lateResponseStatItems: MOCK_LATE_RESPONSE_ITEMS_STATS,

  statutoryTimeframeExceededStats: {
    totalStatutoryConsultationsWithLateResponses: 10,
    totalStatutoryConsultationsWithLateResponsesSubmittedWithin1To7DaysAfterDeadline: 10,
    percentageStatutoryConsultationsWithLateResponsesSubmittedWithin1To7DaysAfterDeadline: 10,
    totalStatutoryConsultationsWithLateResponsesSubmittedWithin8To14DaysAfterDeadline: 10,
    percentageStatutoryConsultationsWithLateResponsesSubmittedWithin8To14DaysAfterDeadline: 10,
    totalStatutoryConsultationsWithLateResponsesSubmittedWithin15To28DaysAfterDeadline: 10,
    percentageStatutoryConsultationsWithLateResponsesSubmittedWithin15To28DaysAfterDeadline: 10,
    totalStatutoryConsultationsWithLateResponsesSubmittedOver29DaysAfterDeadline: 10,
    percentageStatutoryConsultationsWithLateResponsesSubmittedOver29DaysAfterDeadline: 10,
    totalStatutoryLateResponses: 8,
    totalStatutoryLateResponsesSubmitted1to7DaysPostDeadline: 5,
    totalStatutoryWithOutstandingResponses: 3,
  },

  agreedExtensionStats: {
    totalStatutoryConsultationsWithExtensionsTimeframe: 10,
    totalStatutoryConsultationResponsesWithinExtensionTimeframe: 10,
    totalStatutoryConsultationsWithExtensionsTimeframeExtended1To7Days: 10,
    percentageStatutoryConsultationsWithExtensionsTimeframeExtended1To7Days: 10,
    totalStatutoryConsultationsWithExtensionsTimeframeExtended8To14Days: 10,
    percentageStatutoryConsultationsWithExtensionsTimeframeExtended8To14Days: 10,
    totalStatutoryConsultationsWithExtensionsTimeframeExtended15To21Days: 10,
    percentageStatutoryConsultationsWithExtensionsTimeframeExtended15To21Days: 10,
    totalStatutoryConsultationsWithExtensionsTimeframeExtended22To28Days: 10,
    percentageConsultationsWithExtensionsTimeframeExtended22To28Days: 10,
    totalStatutoryConsultationsWithExtensionsTimeframeExtended29PlusDays: 10,
    percentageStatutoryConsultationsWithExtensionsTimeframeExtended29PlusDays: 10,
  },

  nonStatutoryTimelinessResponseStats: {
    totalConsultationRequestsReceived: 500,
    totalConsultationsRespondedInAgreedTimeframe: 400,
    percentageConsultationsRespondedInAgreedTimeframe: 80,
    totalConsultationsWithResponsesWithin21Days: 300,
    percentageConsultationsWithResponsesWithin21Days: 60,
    totalConsultationsRespondedLate: 100,
    percentageConsultationsRespondedLate: 20,
    totalConsultationsWithOutstandingResponses: 10,
    averageDaysTakenToRespondRequests: 2,
  },

  eiaConsultationStats: {
    totalEiaConsultationsReceived: 5,
    averageDaysTakenToRespondToEiaConsultations: 3,
  },

  tqEnTimelinessResponseStats: {},
  tqEnTimeframeExceededStats: {},
  tqEnAgreedExtensionStats: {},
  tqEnAppealConsultationStats: {},
};

export const MOCK_COMPLETED_DFI_ANNUAL_REPORT_RESPONSE_DATA: DfiReportResponse = {
  ...MOCK_DRAFT_DFI_ANNUAL_REPORT_RESPONSE_DATA,
  dateCompleted: new Date('2022-07-01'),
  dateModified: new Date('2022-07-01'),
  path: 'https://placeholder-blob-url.co.uk',
};

export const MOCK_KPI_TITLES: Record<string, string> = {
  agreedExtensionStats: 'Breakdown of Agreed Extensions',
  averageDaysTakenToRespondToEiaConsultations:
    'Average number of days taken to respond to EIA consultations',
  lateResponseStatItems: 'Late Responses (statutory consultations)',
  nonStatutoryTimelinessResponseStats: 'Timeliness of responses (non-statutory consultations)',
  outstandingResponseStats: 'Number of outstanding responses',
  statutoryTimeframeExceededStats: 'Statutory Timeframe Exceeded – Breakdown',
  statutoryTimelinessResponseStats:
    'Timeliness of Consultation Responses (statutory consultations)',
  totalEiaConsultationsReceived: 'Total number of EIA consultations received',
};

export const MOCK_KPI_METRICS: Record<string, unknown> = {
  statutoryTimelinessResponseStats: [
    { label: 'Total number of statutory consultation requests received', value: 8 },
    {
      label:
        'Total number of statutory consultation requests responded to with a substantive response within the agreed timeframe',
      value: 1,
    },
    {
      label:
        'Percentage of statutory consultation requests responded to with a substantive response within the agreed timeframe',
      value: 12,
    },
    {
      label:
        'Total number of statutory consultation requests responded to with a substantive response within 21 days',
      value: 0,
    },
    {
      label:
        'Percentage of statutory consultation requests responded to with a substantive response within 21 days',
      value: 0,
    },
    { label: 'Total number of statutory consultations with late responses issued', value: 2 },
    { label: 'Percentage of statutory consultations with late responses issued', value: 25 },
    { label: 'Total number of statutory consultations with outstanding responses', value: 8 },
    {
      label:
        'Average number of days taken to make a substantive response to statutory requests',
      value: 0,
    },
  ],
  lateResponseStatItems: [
    {
      lateResponseReason: 'Resource issues',
      lateResponseReasonCount: 0,
      lateResponseReasonPercentage: 0,
    },
    {
      lateResponseReason: 'High volume of work',
      lateResponseReasonCount: 1,
      lateResponseReasonPercentage: 50,
    },
    {
      lateResponseReason: 'Extension request refused',
      lateResponseReasonCount: 1,
      lateResponseReasonPercentage: 50,
    },
    {
      lateResponseReason: 'Tech issues - internal to the organisation',
      lateResponseReasonCount: 0,
      lateResponseReasonPercentage: 0,
    },
    {
      lateResponseReason: 'Tech issues - external to the organisation',
      lateResponseReasonCount: 0,
      lateResponseReasonPercentage: 0,
    },
    {
      lateResponseReason: 'Complexity of the case',
      lateResponseReasonCount: 0,
      lateResponseReasonPercentage: 0,
    },
    {
      lateResponseReason: 'Additional information required after consultation',
      lateResponseReasonCount: 0,
      lateResponseReasonPercentage: 0,
    },
    {
      lateResponseReason: 'Other',
      lateResponseReasonCount: 0,
      lateResponseReasonPercentage: 0,
    },
  ],
  statutoryTimeframeExceededStats: [
    { label: 'Total number of statutory consultations with late responses', value: 2 },
    { value: 0 },
    {
      label:
        'Percentage of statutory consultations with late responses submitted within 1-7 days after the agreed deadline',
      value: 0,
    },
    { value: 0 },
    {
      label:
        'Percentage of statutory consultations with late responses submitted within 8-14 days after the agreed deadline',
      value: 0,
    },
    { value: 0 },
    {
      label:
        'Percentage of statutory consultations with late responses submitted within 15-28 days after the agreed deadline',
      value: 0,
    },
    { value: 1 },
    {
      label:
        'Percentage of statutory consultations with late responses submitted over 29 days after the agreed deadline',
      value: 50,
    },
  ],
  agreedExtensionStats: [
    {
      label: 'Total number of statutory consultations with agreed extensions of timeframe',
      value: 0,
    },
    {
      label:
        'Total number of statutory consultation responses returned within an agreed extension timeframe',
      value: 0,
    },
    {
      label:
        'Total number of statutory consultations with agreed extensions of timeframe extended by 1-7 days',
      value: 0,
    },
    {
      label:
        'Percentage of statutory consultations with agreed extensions of timeframe extended by 1-7 days',
      value: 0,
    },
    {
      label:
        'Total number of statutory consultations with agreed extensions of timeframe extended by 8-14 days',
      value: 0,
    },
    {
      label:
        'Percentage of statutory consultations with agreed extensions of timeframe extended by 8-14 days',
      value: 0,
    },
    {
      label:
        'Total number of statutory consultations with agreed extensions of timeframe extended by 15-21 days',
      value: 0,
    },
    {
      label:
        'Percentage of statutory consultations with agreed extensions of timeframe extended by 15-21 days',
      value: 0,
    },
    {
      label:
        'Total number of statutory consultations with agreed extensions of timeframe extended by 22-28 days',
      value: 0,
    },
    {
      label:
        'Percentage of statutory consultations with agreed extensions of timeframe extended by 22-28 days',
      value: 0,
    },
    {
      label:
        'Total number of statutory consultations with agreed extensions of timeframe extended by 29 days and over',
      value: 0,
    },
    {
      label:
        'Percentage of statutory consultations with agreed extensions of timeframe extended by 29 days and over',
      value: 0,
    },
  ],
  outstandingResponseStats: [
    { label: 'Total number of statutory consultations with outstanding responses', value: 8 },
  ],
  totalEiaConsultationsReceived: [
    { label: 'Total number of EIA consultations received', value: 0 },
  ],
  averageDaysTakenToRespondToEiaConsultations: [
    { label: 'Average number of days taken to respond to EIA consultations', value: 0 },
  ],
  nonStatutoryTimelinessResponseStats: [
    { label: 'Total number of non-statutory consultation requests received', value: 12 },
    {
      label:
        'Total number of non-statutory consultations responded to in the agreed timeframe',
      value: 0,
    },
    {
      label: 'Percentage of non-statutory consultations responded to in the agreed timeframe',
      value: 0,
    },
    {
      label:
        'Total number of non-statutory consultations with substantive responses made within 21 calendar days',
      value: 0,
    },
    {
      label:
        'Percentage of of non-statutory consultations with substantive responses made within 21 calendar days',
      value: 0,
    },
    { label: 'Total number of non-statutory consultations responded to late', value: 0 },
    { label: 'Percentage of non-statutory consultations responded to late', value: 0 },
    {
      label: 'Total number of non-statutory consultations with outstanding responses',
      value: 12,
    },
    {
      label:
        'Average number of days taken to make a substantive response to non statutory requests',
      value: 0,
    },
  ],
};
